import { BehaviourItem } from '../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../coaching-tags/models/subbehaviour.coaching.model';
import { BlDocument } from '../../core';
import { Focus } from '../model/focus.model';

export function getFocus(
    behaviours?: BehaviourItem[],
    subBehaviours?: SubBehaviourItem[],
    document?: BlDocument,
): Focus {
    const behaviour = behaviours?.find((b) => b.id === document.behaviourId);
    const subBehaviour = subBehaviours?.find(
        (sb) => sb.id === document.subBehaviourId,
    );

    return {
        behaviourName: behaviour?.name ?? '',
        subBehaviourName: subBehaviour?.name ?? '',
    };
}
